module.exports = __webpack_public_path__ + "static/media/fynd.7fab0ed5.webp";